module.exports = __webpack_public_path__ + "angularjs.f21dd6.svg";